import { render, staticRenderFns } from "./exhibition-buy-consult.vue?vue&type=template&id=9c78fb68&scoped=true&"
import script from "./exhibition-buy-consult.vue?vue&type=script&lang=js&"
export * from "./exhibition-buy-consult.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-buy-consult.vue?vue&type=style&index=0&id=9c78fb68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c78fb68",
  null
  
)

export default component.exports